import { FactoryProvider } from '@angular/core';
import { AskAIConfig, Settings } from '@mri-platform/shared/core';

export const AskAgoraConfigProvider: FactoryProvider = {
  provide: AskAIConfig,
  useFactory: (settings: Settings) => new AskAIConfig(settings.askAgora),
  deps: [Settings]
};
